var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEsports({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFADA",
    d: "M13.198 3.523l.023.01c.376.182.818.865 1.48 4.247.062.412.227 1 .288 2.066.06 1.068-.105 2.146-1.04 2.5-1.246.491-2.006-.696-2.802-3.057l-.025-.038c-.084-.123-.173-.211-.276-.205-.265.235-.54.358-.824.385a1.244 1.244 0 1 0-1.48-1.027v.011c0 .27.107.484.24.63H6.313a.931.931 0 0 0 .239-.63c0-.36-.087-.652-.26-.874a1.242 1.242 0 1 0-1.284 1.892c-.295-.02-.58-.143-.855-.387-.113-.007-.21.101-.301.243l-.048.14c-.77 2.244-1.517 3.375-2.717 2.931l-.038-.014C.033 11.96-.073 10.716.032 9.563c.07-.768.172-1.43.307-1.986.656-3.258 1.145-3.52 1.463-4.054.728-.208 1.425-.205 2.107-.096.682.11 1.265 1.041 1.43 1.037.035-.082 4.139.028 4.176.105.596-.688 1.121-1.069 1.576-1.142.682-.11 1.38-.112 2.107.096zM8.157 8.478H6.843a.188.188 0 0 0-.188.188v.02c0 .104.084.188.188.188h1.314a.188.188 0 0 0 .188-.188v-.02a.188.188 0 0 0-.188-.188zm3.81-4.48a1.797 1.797 0 1 0 0 3.595 1.797 1.797 0 0 0 0-3.595zm-8.99 0a1.797 1.797 0 1 1 0 3.595 1.797 1.797 0 0 1 0-3.595z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6CA19",
    d: "M11.484 5.787a.496.496 0 1 1-.992 0 .496.496 0 0 1 .992 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#48B2FF",
    d: "M12.476 6.91a.496.496 0 1 1-.992 0 .496.496 0 0 1 .992 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC0000",
    d: "M12.476 4.791a.496.496 0 1 1-.992 0 .496.496 0 0 1 .992 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14805E",
    d: "M13.477 5.787a.496.496 0 1 1-.993 0 .496.496 0 0 1 .993 0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.276,
    cy: 8.14,
    r: 1,
    fill: "#FFFADA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.795,
    cy: 8.14,
    r: 1,
    fill: "#FFFADA"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M2.875 4.569H3.1c.08 0 .144.064.144.143v.57l-.275.162-.238-.163v-.569c0-.08.064-.143.144-.143zm0 2.422a.144.144 0 0 1-.144-.144v-.569l.238-.163.275.163v.57a.144.144 0 0 1-.144.143h-.225zM1.776 5.892v-.225c0-.08.064-.144.144-.144h.569l.163.275-.163.238h-.57a.144.144 0 0 1-.143-.144zm2.422 0c0 .08-.064.144-.143.144h-.57l-.162-.238.163-.275h.569c.08 0 .143.065.143.144v.225z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFADA",
    d: "M1.794 2.755c.683-.196 1.387-.239 2.066-.088l.018.375a5.29 5.29 0 0 0-2.066.088l-.018-.375zm11.414 0c-.682-.196-1.387-.239-2.065-.088l-.018.375a5.29 5.29 0 0 1 2.065.088l.018-.375z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsports);
export default __webpack_public_path__ + "static/media/esports.d9aa8a5d42f2d8cc424284cd2a130e74.svg";
export { ForwardRef as ReactComponent };